import {
  Pause,
  Play,
  Repeat,
  Share2,
  Shuffle,
  SkipBack,
  SkipForward,
  Star,
} from 'lucide-react';
import ProgressBar from './ProgressBar';

const MusicPlayerUI = ({ track, isPlaying, currentTime, handlePlayPause }) => {

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
  };

  return (
    <div className="w-full flex items-center">
      <div className="w-full">
        <div className="flex justify-between items-center mb-6">
          <div>
            <h1 className="text-2xl font-bold">{track.title}</h1>
            <p className="text-gray-400">{track.artist}</p>
          </div>
          <div className="flex gap-4">
            <button className="text-gray-400 hover:text-white">
              <Star />
            </button>
            <button className="text-gray-400 hover:text-white">
              <Share2 />
            </button>
          </div>
        </div>
        <div className="mb-6">
          <ProgressBar currentTime={currentTime} className="w-full" />
          <div className="flex justify-between py-1">
            <span className="text-gray-400">{formatTime(currentTime)}</span>
            <span className="text-gray-400">{track.duration}</span>
          </div>
        </div>
        <div className="flex justify-between items-center">
          <button className="text-gray-400 hover:text-white">
            <Shuffle />
          </button>
          <button className="text-gray-400 hover:text-white">
            <SkipBack />
          </button>
          <button
            onClick={handlePlayPause}
            className="bg-charcoal p-[1rem] rounded-full hover:bg-hover-charcoal transition duration-300"
          >
            {isPlaying ? <Pause /> : <Play />}
          </button>
          <button className="text-gray-400 hover:text-white">
            <SkipForward />
          </button>
          <button className="text-gray-400 hover:text-white">
            <Repeat />
          </button>
        </div>
      </div>
    </div>
  );
};

export default MusicPlayerUI;